package com.arena_web.pages

import androidx.compose.runtime.Composable
import com.arena_web.ui.layouts.MobilePageLayout
import com.arena_web.ui.layouts.PageLayout
import com.arena_web.ui.sections.home.HomeShowcase
import com.arena_web.ui.sections.home.mobile.HomeContentMobile
import com.arena_web.ui.utils.isMobile
import com.arena_web.utils.PageSeo
import com.varabyte.kobweb.core.Page
import org.jetbrains.compose.web.css.style
import org.jetbrains.compose.web.dom.Div

// Home carries the keyword-rich SEO title/description (Google is mobile-first,
// so the mobile branch must set them too — MobilePageLayout doesn't).
private const val HOME_SEO_TITLE = "Arena Pro Play — Find Players & Pickup Sports Games Near You"
private const val HOME_SEO_DESCRIPTION =
    "Find people nearby to play football, tennis and other sports. " +
        "Join pickup games, create your own events and meet new players in your city with Arena."

@Page("/")
@Composable
fun HomePage() {
    if (isMobile()) {
        PageSeo(title = HOME_SEO_TITLE, description = HOME_SEO_DESCRIPTION)
        MobilePageLayout(
            mobileReady = true,
            // Marketing home sits on a flat black surface (light: aurora) —
            // overrides the global body composite (blue tint + noise) for the
            // whole layout including the top bar.
            surfaceColor = "var(--arena-bg)",
            edgeToEdge = true,
        ) {
            HomeContentMobile()
        }
    } else {
        // The showcase draws on the full 1920-px desktop canvas (1840-px
        // content + 2×40 PageLayout gutters), but the global --scale floors at
        // 0.4px — in 600–767-px windows the page needs 768 px and the body's
        // overflow:hidden crops both sides. Local override: the width term
        // always wins, the 0.4 floor applies to the height term only, so
        // ≥768-px windows resolve to exactly the global value.
        Div(attrs = {
            style {
                // Silk mounts pages inside a grid Box aligned top-start; a bare
                // block Div there shrinks to content width and hugs the left
                // edge, so it must claim the full viewport itself.
                property("width", "100%")
                property("--scale", "min(calc(100vw / 1920), max(0.4px, calc(100vh / 1080)))")
            }
        }) {
            PageLayout(seoTitle = HOME_SEO_TITLE, description = HOME_SEO_DESCRIPTION) {
                HomeShowcase()
            }
        }
    }
}
